import { IconButton, Menu, MenuCheckBoxItem, MenuContent, MenuTrigger } from '@plaidev/sour-react';
import type { ReactElement } from 'react';

type ColumnOptionsMenuProps = {
  disabled: boolean;
  kanaChecked: boolean;
  onToggleKana: (checked: boolean) => void;
  phoneChecked: boolean;
  onTogglePhone: (checked: boolean) => void;
  showMultiValued: boolean;
  multiValuedChecked: boolean;
  onToggleMultiValued: (checked: boolean) => void;
};

export function ColumnOptionsMenu({
  disabled,
  kanaChecked,
  onToggleKana,
  phoneChecked,
  onTogglePhone,
  showMultiValued,
  multiValuedChecked,
  onToggleMultiValued,
}: ColumnOptionsMenuProps): ReactElement {
  const activeLabels: { key: string; label: string }[] = [];
  if (kanaChecked) activeLabels.push({ key: 'kana', label: 'カナ正規化' });
  if (phoneChecked) activeLabels.push({ key: 'phone', label: '電話番号正規化' });
  if (multiValuedChecked) activeLabels.push({ key: 'multi', label: '複数値' });

  return (
    <div className="flex items-center gap-1.5">
      <Menu>
        <MenuTrigger disabled={disabled}>
          <IconButton size="sm" as="div" variant="quiet" aria-label="列オプション">
            <span aria-hidden className="text-base leading-none">
              ⋯
            </span>
          </IconButton>
        </MenuTrigger>
        <MenuContent align="start" className="w-[220px]">
          <MenuCheckBoxItem checked={kanaChecked} onSelect={(e) => e.preventDefault()} onCheckedChange={(c) => onToggleKana(!!c)}>
            カナ正規化
          </MenuCheckBoxItem>
          <MenuCheckBoxItem checked={phoneChecked} onSelect={(e) => e.preventDefault()} onCheckedChange={(c) => onTogglePhone(!!c)}>
            電話番号正規化
          </MenuCheckBoxItem>
          {showMultiValued ? (
            <MenuCheckBoxItem
              checked={multiValuedChecked}
              onSelect={(e) => e.preventDefault()}
              onCheckedChange={(c) => onToggleMultiValued(!!c)}
            >
              複数値（電話番号など）
            </MenuCheckBoxItem>
          ) : null}
        </MenuContent>
      </Menu>
      <div className="flex min-w-0 flex-wrap items-center gap-1">
        {activeLabels.length === 0 ? (
          <span className="text-xs text-muted-light">—</span>
        ) : (
          activeLabels.map((a) => (
            <span key={a.key} className="inline-flex items-center rounded bg-subtle px-1.5 py-0.5 text-[11px] text-default">
              {a.label}
            </span>
          ))
        )}
      </div>
    </div>
  );
}
